export default __webpack_public_path__ + "/assets/abc-home-Lifestyle_04.jpg";